module.exports = __webpack_public_path__ + "static/media/step2mobile.ae5872cb.png";